export const experienceTransferTranslation = {

  // section title
  experience_transfer: 9619,
  configure_operations_transfer: 9670,

  // search
  search: 9627,
  search_hits: 9630,
  search_no_experience_transfer: 9633,

  // messages
  no_access_to_experience_transfer: 9631,
  experience_transfer_deleted: 9632,
  experience_transfer_updated: 9649,
  experience_transfer_created: 9650,
  operations_updated: 9671,

  // list item
  subscriber_group: 9620,
  criteria: 9621,
  case_type: 9622,
  operation: 9624,
  open: 9664,

  // confirmation
  delete_confirmation: 9634,
  cancel: 9635,
  close: 9668,

  // prompt unsaved
  cancel_changes: 9636,
  are_you_sure: 9637,
  undo_all: 9638,
  go_back: 9639,

  // form messages
  experience_transfer_validation_error: 9640,
  saving_experience_transfer: 9641,
  deleting_experience_transfer: 9642,
  operations_auto_save_info: 9676,
  configure_operations_info_text: 9677,

  // form header
  new_experience_transfer: 9656,
  save: 9643,
  add_new: 9629,
  delete: 9626,
  delete_experience_transfer: 9644,
  active: 9628,
  inactive: 9660,
  manage_options: 9647,

  // validation
  must_be_filled_out: 9645,
  configuration_already_exists: 9653,
  configuration_change_field: 9654,
  done: 9646
};

export type ExperienceTransferTranslation = {
  readonly [T in keyof typeof experienceTransferTranslation]: string
};

export enum queryFilters {
  subscriberGroup = 'subscriber_group',
  criteria = 'criteria'
}
